













































import { Component, Vue } from 'vue-property-decorator';
import EditExchangeRate from './modals/editExchangeRate.vue';

   @Component({
      components:{EditExchangeRate}
    })

export default class ExchangeRateUpdate extends Vue{

  isOpenModal:boolean=false;
  mockData:any[]=[];
  headers:any[]=[];
  breadcrumbsItems:any[]=[];


    created(){
      this.headers= [
          { text: 'Para Birimi',  align: 'start',filterable: false,   value: 'currency', },
          { text: 'Oran', value: 'rate' },
          { text: "İşlemler", value: "transactions" }

        ],
        this.mockData=[
          {
            currency: 'TRY',
            rate: 1,
          },

          {
            currency: 'USD',
            rate: 0.1327,
          },

        ]

        this.breadcrumbsItems= [
          {text: 'Ana Sayfa',disabled: false,href: '/#/main/home'},
          {text: 'Finans',disabled: true},
          {text: 'Kur Oranı Güncelleme',disabled: true}
        
      ]

    }

    data () {
      return {
        page: 1,
}
    }
    
    openModal(){
      this.isOpenModal=true;
    }
    closeModal(){
       this.isOpenModal = false;
    }
    
}




